import { render, staticRenderFns } from "./DonationAction.vue?vue&type=template&id=f23d4b0a&"
import script from "./DonationAction.vue?vue&type=script&lang=js&"
export * from "./DonationAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports